import React, { useEffect, useState, useCallback } from "react";
import Table from "../../common/Table/table";
import AddUpdateUnRegisteredClinic from "./AddUpdateUnRegisteredClinic";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";
import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";
import { useDispatch, useSelector } from "react-redux";
import {
  createUnRegisteredClinic,
  deleteUnRegisteredClinic,
  getAllUnRegisteredClinic,
  resetUnRegisteredClinicCreateMessage,
  resetUnRegisteredClinicDeleteMessage,
  resetUnRegisteredClinicUpdateMessage,
  updateUnregisteredClinic,
} from "../../../store/slices/unRegisteredClinic";
import ViewModal from "../../common/viewModal/globalViewModal";

const UnRegisteredClinic = () => {
  const dispatch = useDispatch();
  const [modalshow, setModalShow] = useState(false);
  const [selectedClinic, setSelectedClinic] = useState(null);
  const [showStatus, setShowStatus] = useState(null);
  const [showGlobalViewModal, setShowGlobalViewModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const showTostifyMessageAndReset = ShowTostifyMessageAndReset();
  const [searchValue, setSearchValue] = useState("");
  const [isUpdateMode, setIsUpdateMode] = useState(false);

  // --- Pagination State ---
  const [pageLimit, setPageLimit] = useState(10);

  const {
    unRegisteredClinic,
    createUnRegisteredClinicErrorMessage,
    createUnRegisteredClinicSuccessMessage,
    deleteUnRegisteredClinicErrorMessage,
    deleteUnRegisteredClinicSuccessMessage,
    updateUnregisteredClinicSuccessMessage,
    updateUnregisteredClinicErrorMessage,
    searchMessage,
    // --- Pagination Selectors ---
    currentPage,
    totalPages,
    totalCount,
    loading,
  } = useSelector((state) => state.unRegisteredClinic);

  const { token } = useSelector((state) => state.auth);
  const { tableStatus } = useSelector((state) => state.tableStatusChange);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const clinicId =clinicInfo?.[0]?.clinicId || null;

  const tableHead = [
    { title: "Clinic Name", key: "name" },
    { title: "Phone", key: "phone" },
    { title: "Status", key: "status" },
  ];
  const title = [
    { title: "Clinic Name", key: "name" },
    { title: "Phone", key: "phone" },
    { title: "Status", key: "status" },
  ];
  const [inputError, setInputError] = useState({
    name: false,
    phNumber: false,
  });

  const [formData, setFormData] = useState({
    clinicName: "",
    phone: "",
    status: "Active",
  });

  // --- Centralized Fetch Logic matching Master pattern ---
  const fetchUnregisteredClinics = useCallback(
    (page = 1, lim = pageLimit, search = searchValue) => {
      if (token && clinicId) {
        dispatch(
          getAllUnRegisteredClinic({
            clinicId,
            clinicName: search || undefined,
            status: tableStatus,
            token,
            currentPage: page,
            limit: lim,
          }),
        );
      }
    },
    [dispatch, token, tableStatus, searchValue, pageLimit, clinicId],
  );

  useEffect(() => {
    if (clinicId) {
      fetchUnregisteredClinics(1, pageLimit, searchValue);
    }
  }, [
    dispatch,
    token,
    tableStatus,
    fetchUnregisteredClinics,
    modalshow,
    deleteModal,
    clinicId,
    pageLimit,
    searchValue,
  ]);

  // --- Pagination Handlers ---
  const handlePageChange = (page) => {
    fetchUnregisteredClinics(page, pageLimit, searchValue);
  };

  const handleLimitChange = (newLimit) => {
    setPageLimit(newLimit);
    fetchUnregisteredClinics(1, newLimit, searchValue);
  };

  useEffect(() => {
    showTostifyMessageAndReset(
      createUnRegisteredClinicSuccessMessage,
      showToastifySuccess,
      resetUnRegisteredClinicCreateMessage,
    );
    showTostifyMessageAndReset(
      createUnRegisteredClinicErrorMessage,
      showToastifyError,
      resetUnRegisteredClinicCreateMessage,
    );
    showTostifyMessageAndReset(
      deleteUnRegisteredClinicSuccessMessage,
      showToastifySuccess,
      resetUnRegisteredClinicDeleteMessage,
    );
    showTostifyMessageAndReset(
      deleteUnRegisteredClinicErrorMessage,
      showToastifyError,
      resetUnRegisteredClinicDeleteMessage,
    );
    showTostifyMessageAndReset(
      updateUnregisteredClinicSuccessMessage,
      showToastifySuccess,
      resetUnRegisteredClinicUpdateMessage,
    );
    showTostifyMessageAndReset(
      updateUnregisteredClinicErrorMessage,
      showToastifyError,
      resetUnRegisteredClinicUpdateMessage,
    );
  }, [
    createUnRegisteredClinicErrorMessage,
    createUnRegisteredClinicSuccessMessage,
    deleteUnRegisteredClinicErrorMessage,
    deleteUnRegisteredClinicSuccessMessage,
    updateUnregisteredClinicSuccessMessage,
    updateUnregisteredClinicErrorMessage,
    dispatch,
    showTostifyMessageAndReset,
  ]);

  const handlemodal = () => {
    setIsUpdateMode(false);
    setFormData({
      clinicName: "",
      phone: "",
      status: "Active",
    });
    setModalShow(true);
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    fetchUnregisteredClinics(1, pageLimit, value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEdit = (item) => {
    setFormData({
      clinicName: item?.name,
      phone: item?.phone,
      status: item?.status,
    });
    setIsUpdateMode(true);
    setModalShow(true);
    setSelectedClinic(item);
  };

  const handleDelete = (item) => {
    setDeleteModal(true);
    setSelectedClinic(item);
  };

  const handleDeleteClinic = async () => {
    try {
      await dispatch(
        deleteUnRegisteredClinic({
          clinicId,
          id: selectedClinic?.id,
          token,
        }),
      );
      setDeleteModal(false);
    } catch (error) {
      console.error(error);
    }
  };

  const handleUpdateStatus = async (status, item) => {
    try {
      const updatedData = {
        id: item?.id,
        clinicName: item.name,
        phone: item.phone,
        status,
      };
      await dispatch(
        updateUnregisteredClinic({ clinicId, updatedData, token }),
      );
      fetchUnregisteredClinics(currentPage, pageLimit, searchValue);
    } catch (error) {}
  };

  const handleAddUpdate = async (e) => {
    e.preventDefault();
    const { name, phNumber } = inputError;
    if (name || phNumber) return;
    try {
      if (isUpdateMode) {
        await dispatch(
          updateUnregisteredClinic({
            clinicId,
            updatedData: {
              id: selectedClinic?.id,
              clinicName: formData?.clinicName,
              phone: formData?.phone,
              status: formData?.status,
            },
            token,
          }),
        );
      } else {
        await dispatch(
          createUnRegisteredClinic({
            clinicId,
            clinicName: formData?.clinicName,
            phone: formData?.phone,
            status: formData?.status,
            token,
          }),
        );
      }
      setIsUpdateMode(false);
      setModalShow(false);
      setFormData({});
    } catch (error) {
      console.error(error);
    }
  };

  const handleShowGlobalViewModal = (data) => {
    setFormData(data);
    setShowGlobalViewModal(true);
  };

  return (
    <>
      <Table
        tableBody={
          unRegisteredClinic &&
          unRegisteredClinic.map((item) => ({
            id: item?._id,
            name: item?.clinicName,
            phone: item?.phone,
            status: item?.status,
          }))
        }
        tableHead={tableHead}
        handleAddBtn={true}
        addModal={handlemodal}
        handleSearch={handleSearch}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        searchValue={searchValue}
        errorMessage={searchMessage}
        showStatus={showStatus}
        setShowStatus={setShowStatus}
        handleUpdateStatus={handleUpdateStatus}
        handleShowGlobalViewModal={handleShowGlobalViewModal}
        // --- Pagination Props for Table Component ---
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        limit={pageLimit}
        onPageChange={handlePageChange}
        onLimitChange={handleLimitChange}
        showPagination={true}
        showLimitDropdown={true}
        isLoading={loading}
      />

      <AddUpdateUnRegisteredClinic
        modalshow={modalshow}
        setModalShow={setModalShow}
        formData={formData}
        setFormData={setFormData}
        setInputError={setInputError}
        handleAddUpdate={handleAddUpdate}
        handleChange={handleChange}
        isUpdateMode={isUpdateMode}
        setInputTextError={setInputError}
      />

      <ViewModal
        showGlobalViewModal={showGlobalViewModal}
        setShowGlobalViewModal={setShowGlobalViewModal}
        modalSize={"lg"}
        titel={title && title}
        content={{
          name: formData?.name,
          phone: formData?.phone,
          status: formData?.status,
        }}
      />

      <Modal centered show={deleteModal} onHide={() => setDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Are You Sure Want to delete it?</Modal.Title>
        </Modal.Header>
        <Modal.Body>Please Delete It Carefully</Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => setDeleteModal(false)}
            className="p-2"
          >
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDeleteClinic} className="p-2">
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default UnRegisteredClinic;
